import React, { Component } from 'react';
import { ModalHeader, Modal, Form, ModalBody, Button, Col, Input, InputGroup, InputGroupAddon, InputGroupText, Row } from 'reactstrap';
import PropTypes from 'prop-types';

import { LoginContext } from "../../components/ParadigmaLoginProvider";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			username: "",
			password: "",
			errorMsg:"",
			usernameInvitado:"ventas3@darsur.com.ar",
			passwordInvitado:"SUR8477",
			emailInvitado:"",
			codPostalInvitado:"",
			nombreInvitado:"",
			disabled: false,
			showPassword: false,
		};
		this.username = React.createRef();
		this.password = React.createRef();
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.open == true) {
			setTimeout(
				()=>{
					if(this.username.current != null && this.password.current!=null){
						const validate = (str)=>str!=undefined && str!=null && str!="";
						this.setState(
							{
								username:validate(this.username.current.defaultValue) ? this.username.current.defaultValue : "",
								password:validate(this.password.current.defaultValue) ? this.password.current.defaultValue : "",
							},
							//()=>console.log("log", this.state.username, this.state.password)
						);
					}
				},
				100
			);
		}
	}

	static propTypes = {
		open: PropTypes.bool,
		onClose: PropTypes.func,
		onLogin: PropTypes.func,
	}

	canLoginInvitado(){
		const { username, password, nombreInvitado, codPostalInvitado, emailInvitado } = this.state;
		if (nombreInvitado === "") { return false; }
		if (codPostalInvitado === "") { return false; }
		if (emailInvitado === "") { return false; }
		return true;
	}
	canLogin() {
		const { username, password, nombreInvitado, codPostalInvitado, emailInvitado } = this.state;
		if (username === "") { return false; }
		if (password === "") { return false; }
		return true;
	}

	toggleShowPassword = () => {
		this.setState(prevState => ({
			showPassword: !prevState.showPassword
		}));
	};

	render() {
		const { open, onClose } = this.props;
		const { username, password, nombreInvitado, codPostalInvitado, emailInvitado, usernameInvitado, passwordInvitado, disabled, errorMsg, showPassword } = this.state;
		return (
			<LoginContext.Consumer>
			{
				({ logged, login, errorMsg, loginInvitado }) => {
					return (
						<Modal className="modal-lg" centered isOpen={open} toggle={() => (onClose ? onClose() : null)}>
						<ModalHeader className="px-4">
						Ingresá a tu cuenta
						</ModalHeader>
						<ModalBody className="px-4">
						<Form autoComplete="on" onSubmit={()=>false}>
						<InputGroup className="mb-3">
						<InputGroupAddon addonType="prepend">
						<InputGroupText>
						<i className="icon-envelope"></i>
						</InputGroupText>
						</InputGroupAddon>
						<Input
						innerRef={this.username}
						disabled={disabled} value={username}
						onKeyDown={(e) => {
							if (e.keyCode === 13 && this.canLogin()) {
								login(username, password, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								})
							}
						}}
						onChange={(e) => this.setState({ username: e.target.value })}
						type="text" placeholder="Email" autoComplete="on"
						/>
						</InputGroup>
						<InputGroup className="mb-4">
						<InputGroupAddon addonType="prepend">
						<InputGroupText>
						<i className="icon-lock"></i>
						</InputGroupText>
						</InputGroupAddon>
						<Input
						innerRef={this.password}
						disabled={disabled} value={password}
						onKeyDown={(e) => {
							if (e.keyCode === 13 && this.canLogin()) {
								login(username, password, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								})
							}
						}}
						onChange={(e) => this.setState({ password: e.target.value })}
						type={showPassword ? 'text' : 'password'} placeholder="Contraseña" autoComplete="on"
						/>
						<InputGroupAddon>
                        <button type="button" onClick={this.toggleShowPassword} className="btn btn-outline-primary">
							<i class="fa fa-eye" aria-hidden="true"></i>
                        </button>
                    	</InputGroupAddon>
						</InputGroup>
						<h6 className={".text-warning"}>{errorMsg}</h6>
						<p className="border-top"></p>
						<ModalHeader className="px-4">
						Ingrese como un usuario Invitado
						</ModalHeader>
						<InputGroup className="mb-3">
						<InputGroupAddon addonType="prepend">
						<InputGroupText>
						<i className="icon-user"></i>
						</InputGroupText>
						</InputGroupAddon>
						<Input
						disabled={disabled} value={nombreInvitado}
						onKeyDown={(e) => {
							if (e.keyCode === 13 && this.canLoginInvitado()) {
								loginInvitado(usernameInvitado, passwordInvitado, nombreInvitado, emailInvitado, codPostalInvitado, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								})
							}
						}}
						onChange={(e) => this.setState({ nombreInvitado: e.target.value })}
						type="text" placeholder="Nombre / Razón Social" autoComplete="on"
						/>
						</InputGroup>
						<InputGroup className="mb-3">
						<InputGroupAddon addonType="prepend">
						<InputGroupText>
						<i className="icon-envelope"></i>
						</InputGroupText>
						</InputGroupAddon>
						<Input
						disabled={disabled} value={emailInvitado}
						onKeyDown={(e) => {
							if (e.keyCode === 13 && this.canLoginInvitado()) {
								loginInvitado(usernameInvitado, passwordInvitado, nombreInvitado, emailInvitado, codPostalInvitado, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								})
							}
						}}
						onChange={(e) => this.setState({ emailInvitado: e.target.value })}
						type="text" placeholder="Email" autoComplete="on"
						/>
						</InputGroup>
						<InputGroup className="mb-3">
						<InputGroupAddon addonType="prepend">
						<InputGroupText>
						<i className="fa fa-building-o"></i>
						</InputGroupText>
						</InputGroupAddon>
						<Input
						disabled={disabled} value={codPostalInvitado}
						onKeyDown={(e) => {
							if (e.keyCode === 13 && this.canLoginInvitado()) {
								loginInvitado(usernameInvitado, passwordInvitado, nombreInvitado, emailInvitado, codPostalInvitado, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								})
							}
						}}
						onChange={(e) => this.setState({ codPostalInvitado: e.target.value })}
						type="text" placeholder="Cod. Postal" autoComplete="on"
						/>
						</InputGroup>
						<p className="border-top"></p>
						<Row>
						<Col sm={4} className="mx-auto">
						<Button
						disabled={(!(username !== "" && password !== "") && !(emailInvitado.trim() !== "" && codPostalInvitado.trim() !== "" && nombreInvitado.trim() !== "")) || disabled}
						onClick={ evt =>{
							evt.preventDefault();
							if (this.canLogin()) {
								login(username, password, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								});
							}
							else if (this.canLoginInvitado()){
								loginInvitado(usernameInvitado, passwordInvitado, nombreInvitado, emailInvitado, codPostalInvitado, (result) => {
									if (result) this.setState({ username: "", password: "", nombreInvitado:"", emailInvitado:"", codPostalInvitado:"" });
									if (result && onClose) onClose();
								});
							}
						}}
						type="submit" style={{ backgroundColor: '#2b4464', color: '#fff', borderRadius: '12px' }}  className="px-4 py-2 w-100">
						{disabled && <i className={"fa fa-refresh fa-refresh-animated"}></i>}
						INGRESAR
						</Button>
						</Col>
						</Row>
						</Form>
						</ModalBody>
						</Modal>
					)
				}
			}
			</LoginContext.Consumer>
		);
	}
}
export default Login;



// WEBPACK FOOTER //
// ./src/views/Login/Login.js